import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { USER_MANAGEMENT_DIALOG_ACTIONS } from '../../actions';
import { EditIrisIdDialogComponent } from '../components';
import { irisIdData } from '@data-access/user-management/types';
import { DialogSize } from '@wcg/frontend-framework';

@Injectable({
  providedIn: 'root',
})
export class EditIrisIdDialogService {
  private readonly _store = inject(Store);

  openUserManagementDialog(data: irisIdData): void {
    this._store.dispatch(
      USER_MANAGEMENT_DIALOG_ACTIONS.openUserManagementDialog({
        component: () => EditIrisIdDialogComponent,
        data: { ...data, size: DialogSize.SMALL },
      }),
    );
  }
}
